export default __webpack_public_path__ + "static/media/RU.cc0461cb.svg";